module.exports = __webpack_public_path__ + "static/media/account.bdb16b80.png";